import { Directive, ElementRef, Inject, Renderer2 } from '@angular/core';

import { APP_CONFIG, IAppConfig } from '@app/core/services/app.config';

@Directive({
  selector: '[appSetBackground]',
})
export class SetBackgroundDirective {
  constructor(
    @Inject(APP_CONFIG) private readonly appConfig: IAppConfig,
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {
    this.renderer.listen(this.elementRef.nativeElement, 'click', event => {
      this.setBg(event.target, true);
    });
    this.renderer.listen(this.elementRef.nativeElement, 'mouseover', event => {
      this.setBg(event.target, true);
    });
    this.setBg(this.elementRef.nativeElement);
  }

  private setBg(nativeElement, forEvent = false): void {
    window.setTimeout(() => {
      const name = this.appConfig.settings.config_name;
      if (forEvent) {
        this.renderer.removeStyle(nativeElement, 'background-image');
      }
      const style = window.getComputedStyle(nativeElement);
      this.renderer.setStyle(
        this.elementRef.nativeElement,
        'background-image',
        style.backgroundImage.replace(
          /.+core/g,
          `url("${this.appConfig.configsUrl}configs/${name}`,
        ),
      );
    }, 0);
  }
}
